import NProgress from 'nprogress'
import type { Router } from 'vue-router'
import 'nprogress/nprogress.css'

/**
 * 路由切换顶部进度条。
 *
 * - 路由 beforeEach 触发：start()
 * - 路由 afterEach 触发：done()
 * - 颜色由 CSS 覆盖（品牌色 #40E0FF）
 * - 关闭 spinner：减少视觉噪音
 */
NProgress.configure({
  showSpinner: false,
  trickleSpeed: 120,
  minimum: 0.15,
})

export function setupRouterProgress(router: Router) {
  router.beforeEach((to, from) => {
    if (to.path !== from.path) {
      NProgress.start()
    }
  })
  router.afterEach(() => {
    NProgress.done()
  })
  router.onError(() => {
    NProgress.done()
  })
}
